jQuery(function($){
  if ($('.accordion').length){
    $('.accordion-js').on('click', function(){
      var $parent = $(this).parent();
      if ($parent.hasClass('active')){
        $parent.removeClass('active');
        $parent.find('.accordion__content').css('max-height', '0');
      } else {
        $parent.addClass('active');
        $parent.find('.accordion__content').css('max-height', $parent.find('.accordion__content').prop('scrollHeight'));
      }
    });
  }
});